export default `/* Ids Modal Component */
:host {
  display: block;
  position: fixed;
  visibility: visible;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

:host(:not([visible])) {
  pointer-events: none;
  visibility: hidden;
}

.ids-modal {
  display: block;
  pointer-events: none;
}
.ids-modal[visible] {
  pointer-events: auto;
}
.ids-modal.fullsize {
  height: 100%;
}
.ids-modal.fullsize .ids-modal-container {
  height: 100% !important;
  min-height: 100% !important;
  max-height: 100% !important;
  width: 100% !important;
}
.ids-modal.fullsize .ids-modal-header + .ids-modal-content {
  overflow-y: auto;
}
.ids-modal:not(.scrollable) .has-scrollbar {
  overflow: hidden;
  padding: 0;
}
.ids-modal.scrollable .has-scrollbar {
  overflow: auto;
}
.ids-modal:not(.fullsize)::part(popup) {
  max-height: calc(100% - 32px);
}

.ids-modal-header {
  padding: var(--ids-modal-header-padding);
}

.ids-modal-content {
  padding: var(--ids-modal-content-padding);
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}

.ids-modal-header + .ids-modal-content {
  padding-block-start: 0;
}

.ids-modal-header,
.ids-modal-footer {
  align-items: center;
  display: flex;
}

.ids-modal-footer {
  margin: var(--ids-modal-footer-margin);
  border-top: 1px solid var(--ids-modal-footer-color-border);
}
.ids-modal-footer[hidden] {
  border-top: none;
}

.ids-modal-container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  width: 100%;
  max-height: calc(100vh - 64px);
}

::slotted([slot=buttons]) {
  flex-grow: 1;
  display: flex;
}

.modal-control-close {
  position: absolute;
  top: var(--ids-space-2xs);
  right: var(--ids-space-2xs);
}
.modal-control-close[dir=rtl] {
  left: var(--ids-space-2xs);
  right: unset;
}

::slotted([slot=buttons]:not(:first-of-type)) {
  border-inline-start: 1px solid var(--ids-modal-footer-color-border);
}

.ids-modal-button:not(.ids-modal-icon-button):not(:first-of-type) {
  border-left: 1px solid var(--ids-modal-footer-color-border);
}

::slotted([slot=title]) {
  overflow-wrap: var(--ids-message-overflow-wrap, normal);
}

@media screen and (min-width: 767px) {
  ::slotted([slot=title]) {
    font-size: var(--ids-font-size-lg);
  }
}
.ids-modal.ids-about .ids-modal-content.has-scrollbar {
  overflow: auto;
  padding: var(--ids-about-content-padding);
  height: 75%;
}

.ids-about .ids-modal-container {
  max-width: var(--ids-about-width-max);
  min-width: var(--ids-about-width-min);
}
.ids-about .ids-modal-container .modal-control-close {
  z-index: var(--ids-z-index-10);
}
.ids-about .ids-modal-header {
  justify-content: space-evenly;
  flex-direction: column;
  width: calc(100% - 40px);
}
.ids-about .ids-modal-content-wrapper {
  padding-block: 4px;
  padding-inline: 24px;
  margin-block-end: 20px;
  overflow: hidden;
}
.ids-about .ids-modal-content {
  border: 1px solid var(--ids-about-color-border-default);
  padding: var(--ids-about-content-padding);
  margin-block-start: 0;
  margin-block-end: 24px;
  border-radius: var(--ids-border-radius-2xs);
  max-height: 160px;
  outline: 0;
  overflow: auto;
  text-align: left;
  scroll-behavior: smooth;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ids-about .ids-modal-content:focus {
  border-color: var(--ids-about-color-border-focus);
  box-shadow: var(--ids-about-shadow-focus);
  outline: 0;
  outline-color: var(--ids-color-transparent);
}
.ids-about .ids-modal-content:hover {
  border-color: var(--ids-about-color-border-hover);
}

::slotted([slot=product]),
::slotted([slot=content]),
::slotted([slot=copyright]) {
  display: block;
  margin-block-end: 24px;
}

::slotted([slot=icon]) {
  margin-block-end: 4px;
}
::slotted([slot=icon])[icon=logo-white-trademark] {
  margin-block-start: 8px;
  margin-block-end: 8px;
}

::slotted([icon=logo-white-trademark]) {
  margin-block-start: 18px;
  margin-block-end: 8px;
}

::slotted([slot=buttons]) {
  position: absolute;
  top: 4px;
  right: 4px;
}

::slotted([slot=buttons]:not(:first-of-type)) {
  border-left: var(--ids-color-transparent);
}

:host([dir=rtl]) ::slotted([slot=buttons]) {
  left: 4px;
  right: unset;
}
:host([dir=rtl]) .ids-modal-content {
  text-align: right;
}

div.ids-modal {
  pointer-events: initial;
}

@media (max-width: 767px) {
  div.ids-modal {
    margin-left: calc(300px - 50%);
    margin-right: 5%;
  }
  .ids-about .ids-modal-content {
    max-height: 400px;
  }
}
#copy-to-clipboard {
  position: absolute;
  right: 4px;
  bottom: 7px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
